<script setup>
// GK-HUB: Auto-resolve per inbox settings page
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import AutoResolveConfig from 'dashboard/components-next/auto-resolve/AutoResolveConfig.vue';

const props = defineProps({
  inbox: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();
const store = useStore();
const labels = useMapGetter('labels/getLabels');
const isSubmitting = ref(false);

const config = computed(() => ({
  auto_resolve_after: props.inbox.auto_resolve_after,
  auto_resolve_message: props.inbox.auto_resolve_message,
  auto_resolve_ignore_waiting: props.inbox.auto_resolve_ignore_waiting,
  auto_resolve_label: props.inbox.auto_resolve_label,
}));

const updateInbox = async attributes => {
  try {
    isSubmitting.value = true;
    await store.dispatch('inboxes/updateInbox', {
      id: props.inbox.id,
      formData: false,
      ...attributes,
    });
    useAlert(t('GENERAL_SETTINGS.FORM.AUTO_RESOLVE.DURATION.API.SUCCESS'));
  } catch {
    useAlert(t('GENERAL_SETTINGS.FORM.AUTO_RESOLVE.DURATION.API.ERROR'));
  } finally {
    isSubmitting.value = false;
  }
};

const handleSave = async config => {
  await updateInbox(config);
};

const handleDisable = async () => {
  await updateInbox({
    auto_resolve_after: null,
    auto_resolve_message: '',
    auto_resolve_ignore_waiting: false,
    auto_resolve_label: null,
  });
};
</script>

<template>
  <div class="mx-8 my-5">
    <AutoResolveConfig
      :config="config"
      :labels="labels"
      :is-submitting="isSubmitting"
      :note="t('GENERAL_SETTINGS.FORM.AUTO_RESOLVE.INBOX_NOTE')"
      show-inherit
      @save="handleSave"
      @disable="handleDisable"
    />
  </div>
</template>
